import { gsap } from "gsap";
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';
gsap.registerPlugin(ScrollTrigger, SplitText);

import flipbutton from '../snippets/flipbutton'
import { onWidthResize, offWidthResize } from '../utils/resize.js';

export default class CollectionSelected {
    constructor(container) {
        this.container = container;
        this.title = this.container.querySelector('.collection-selected__title');
        this.product_cards = this.container.querySelectorAll('.product-card');
        this.flipbuttons = this.container.querySelectorAll('.collection-selected__footer .js-flipbutton');

        this.init();
    }

    init = () => {
        this.text_lines = new SplitText(this.title, { type: 'lines,words', linesClass: "lineParent" });
        gsap.fromTo(this.text_lines.words,
            { yPercent: 100, }, {
            yPercent: 0, duration: 0.6, stagger: { each: 0.1, ease: 'power.out', from: 'start' }, ease: 'power3.out',
            scrollTrigger: { trigger: this.container },
            onComplete: () => {
                onWidthResize(this.onResize);
            }
        });


        gsap.set(this.product_cards, { opacity: 0, yPercent: 40 });
        ScrollTrigger.batch(this.product_cards, {
            interval: 0.2,
            batchMax: 7,
            start: "top-=40px bottom",
            toggleActions: "play pause resume reset",
            onEnter: (element, e) => {
                gsap.to(element, { opacity: 1, yPercent: 0, duration: 1.6, delay: 0, stagger: { each: 0.1 }, overwrite: 'auto', ease: 'expo.out', });
            },
            // markers:true
        });

        this.flipbuttons.forEach(element => {
            new flipbutton(element);
        });
    }


    onResize = () => {
        this.text_lines.revert();
        offWidthResize(this.onResize);
    }
}
